







import { VueCustom } from 'vue-custom';
import { EXTENSION_ID, SFX_PATH, SFX_CLICK_FILE } from 'constants/audio';
import EventsManager from 'managers/events.manager';

export default VueCustom.extend({
  name: 'audio-extension',
  computed: {
    id() {
      return EXTENSION_ID;
    },
    srcOGG() {
      return `${ SFX_PATH }${ SFX_CLICK_FILE }.ogg`;
    },
    srcM4A() {
      return `${ SFX_PATH }${ SFX_CLICK_FILE }.m4a`;
    },
  },
  methods: {
    onMetaData() {
      EventsManager.emit('AUDIO_EXTENSION');
    },
  },
});
